module.exports = __webpack_public_path__ + "img/edit.ee3f8680.svg";